import type { RecipientOption } from '@/api/send_cart/model/sendCartModel'
import type { CartDocumentBox } from '@/views/SendCart/typeData'

export interface CartRecipient {
  sendable: boolean
  message_code: string
  message: string
  recipient_id: number
  recipient_corporate_id: number
  recipient_corporate_number: number
  recipient_corporate_name: string
  recipient_client_code: string
  recipient_client_name: string
  recipient_department_name: string
  recipient_user_name: string
  recipient_user_id: number
  recipient_folder_id: number
  recipient_folder_name: string
  recipient_mail: string
}

export interface CartDocument {
  product_id: number
  document_id: number
  file_id: number
  file_name: string
  file_path: string
  file_size: number
  product_folder_id: number
  owner_product_code: string
  owner_product_name: string
  file_upload_corporate_id: number
  insert_user_family_name: string
  insert_user_given_name: string
  latest_edition_flag: string
  insert_datetime: string
  update_datetime: string
  document_type: string
  revision_date: string
}

export interface State {
  current_page: number
  total_count: number
  detail: CartDocumentBox
  disable_send: boolean
  unknow_corporate: boolean
  unknow_user: boolean
  //送信先選択
  recipientOptions: RecipientOption[]
  sideBarClick: string
  // 確認画面へ遷移可能か
  allowMoveToConfirmView: boolean

  /** @description 送信可能かどうか */
  sendable: boolean
  /** @description 送信不可時のメッセージ */
  sendableCheckedMessage: string
}

const state = (): State => ({
  current_page: 0,
  total_count: 0,
  detail: {} as CartDocumentBox,
  disable_send: false,
  unknow_corporate: false,
  unknow_user: false,
  recipientOptions: [],
  sideBarClick: '',
  allowMoveToConfirmView: true,
  sendable: false,
  sendableCheckedMessage: '',
})

export default state
